import React, { useEffect } from 'react'
import { Cart, CartDetails, Couriers, Customers, Dashboard, ForgotPassword, Invoice, OrderDetails, Orders, ResetPassword, SignIn, SuccessPassword } from './pages'
import { BrowserRouter as Router, Routes, Route, useLocation, useNavigate } from 'react-router-dom'
import { PublicRoute, ProtectedRoute, ScrollToTop } from './components'
import { useDispatch, useSelector } from 'react-redux'
import { toast, ToastContainer } from "react-toastify";
import Layout from './layout'
import { clearAdminData } from './redux/reducers/authReducer'
import axios from 'axios'

import Modal from 'react-modal'

Modal.setAppElement('#root');

const AppContent = () => {
  const { token, adminDetails } = useSelector((state) => state.admin);
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // Define routes that shouldn't display the Header or MobileHeader
  const noHeaderRoutes = [
    '/login', '/forgot-password', '/reset-password', '/success-password',
    '/order/:orderNumber/:id/view'
  ];
  const hideScreen = noHeaderRoutes.includes(location.pathname);

  useEffect(() => {
    const setUserId = async () => {
      try {
        if (token && adminDetails?.id) {
          // Store user ID if token and adminDetails exist
          await localStorage.setItem('user_id', adminDetails.id.toString());
        } else {
          // Generate and store a guest ID if token is missing
          const storedUserId = `guest-${Math.random().toString(36).substr(2, 9)}`;
          await localStorage.setItem('user_id', storedUserId);
        }
      } catch (error) {
        console.error('Error setting user_id in AsyncStorage:', error);
      }
    };
    setUserId();

  }, [token, adminDetails]); // Runs whenever token or adminDetails change

  useEffect(() => {
    const interceptor = axios.interceptors.response.use(
      response => response,
      error => {
        if (
          error.response?.status === 401 &&
          error.response?.data?.message === 'Unauthenticated.'
        ) {
          dispatch(clearAdminData());
          toast.error('Session expired. Please log in again.');
          navigate('/login');
        }
        return Promise.reject(error);
      }
    );

    // Cleanup
    return () => {
      axios.interceptors.response.eject(interceptor);
    };
  }, [dispatch, navigate]);

  return (
    <>
      {!hideScreen && (
          <>
            {/* Layout here */}
          </>
      )}
      <Routes>  
        {/* Public Routes */}
        <Route path="/login" element={<PublicRoute><SignIn /></PublicRoute>} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/success-password" element={<SuccessPassword />} />

        {/* Protected Routes */}
        {/* <Route path="/" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} /> */}
        <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
          <Route index element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/couriers" element={<ProtectedRoute><Couriers /></ProtectedRoute>} />
          <Route path="/customers" element={<ProtectedRoute><Customers /></ProtectedRoute>} />
          <Route path="/orders" element={<ProtectedRoute><Orders /></ProtectedRoute>} />
          <Route path="/order/:orderNumber/:id/view" element={<ProtectedRoute><Invoice /></ProtectedRoute>} />
          <Route path="/order/:orderNumber/:id/edit" element={<ProtectedRoute><OrderDetails /></ProtectedRoute>} />
          <Route path="/cart" element={<ProtectedRoute><Cart /></ProtectedRoute>} />
          <Route path="/cart/:id" element={<ProtectedRoute><CartDetails /></ProtectedRoute>} />
        </Route>
        
      </Routes>
      <ToastContainer />
    </>
  );
};

const App = () => (
  <Router basename='/'>
    <ScrollToTop />
    <AppContent />
  </Router>
);

export default App